// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ChecklistModalController from "./checklist_modal_controller"
application.register("checklist-modal", ChecklistModalController)

import ChecklistSubmissionUiController from "./checklist_submission_ui_controller"
application.register("checklist-submission-ui", ChecklistSubmissionUiController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ModalSubmitController from "./modal_submit_controller"
application.register("modal-submit", ModalSubmitController)

import OutletSyncController from "./outlet_sync_controller"
application.register("outlet-sync", OutletSyncController)

import OutletSyncToastController from "./outlet_sync_toast_controller"
application.register("outlet-sync-toast", OutletSyncToastController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import RevealSecretController from "./reveal_secret_controller"
application.register("reveal-secret", RevealSecretController)

import RoleCheckboxController from "./role_checkbox_controller"
application.register("role-checkbox", RoleCheckboxController)

import SalesChartController from "./sales_chart_controller"
application.register("sales-chart", SalesChartController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)
